<template>
  <TabbedPortletOpportunity>
    <TabbedPortletHead>
      <li class="nav-item">
        <a
          href=""
          class="nav-link"
          :class="{ 'active': selectedTab === tabs.OPPORTUNITY_DETAILS_TAB }"
          @click.prevent="selectTab(tabs.OPPORTUNITY_DETAILS_TAB)">Opportunity Details</a>
      </li>
      <li class="nav-item">
        <a
          href=""
          class="nav-link"
          :class="{ 'active': selectedTab === tabs.CLIENT_INFORMATION_TAB }"
          @click.prevent="selectTab(tabs.CLIENT_INFORMATION_TAB)">Client Information</a>
      </li>
      <li class="nav-item">
        <a
          href=""
          class="nav-link"
          :class="{ 'active': selectedTab === tabs.QUOTE_REQUEST_FORM_TAB }"
          @click.prevent="selectTab(tabs.QUOTE_REQUEST_FORM_TAB)">Quote request form</a>
      </li>
      <div style="align-self: center; position: absolute; right: 0;">
        <a href="#" @click="showParentModal = true">
          Source
        </a>
      </div>
    </TabbedPortletHead>

    <TabbedPortletBody>
      <div class="tab-content">

        <TabbedPortletBodyTab :show="selectedTab === tabs.OPPORTUNITY_DETAILS_TAB">
          <OpportunityDetailsTab
            v-if="opportunityDetails && opportunity"
            :validationGroupName="validationGroupName"
            :data="opportunity"
            :isCompletedQuote="isCompletedQuote" />
        </TabbedPortletBodyTab>

        <TabbedPortletBodyTab :show="selectedTab === tabs.CLIENT_INFORMATION_TAB" >
          <ClientInformationTab
            v-if="clientDetails"
            :validationGroupName="validationGroupName"
            :isCompletedQuote="isCompletedQuote" />
        </TabbedPortletBodyTab>

        <TabbedPortletBodyTab :show="selectedTab === tabs.QUOTE_REQUEST_FORM_TAB">
          <QuoteRequestFormTab
            v-if="opportunityDetails"
            :validationGroupName="validationGroupName"
            :save="save"
            :isCompletedQuote="isCompletedQuote" />
        </TabbedPortletBodyTab>
      </div>
    </TabbedPortletBody>
    <Portal to="parentInfoPortal">
      <ParentInfoModal
        v-if="itinerary"
        :show="showParentModal"
        :parent-itinerary="itinerary.parent_itinerary"
        :parent-tour="itinerary.parent_tour"
        :close-modal="() => showParentModal = false"
      />
    </Portal>
  </TabbedPortletOpportunity>
</template>

<script>
// Fork: OpportunityDetails.vue

import { mapGetters } from 'vuex'

import TabbedPortletOpportunity from '@/components/_shared/tabbed-portlet-opportunity/TabbedPortletOpportunity.vue'
import TabbedPortletHead from '@/components/_shared/tabbed-portlet/TabbedPortletHead.vue'
import TabbedPortletBody from '@/components/_shared/tabbed-portlet/TabbedPortletBody.vue'
import TabbedPortletBodyTab from '@/components/_shared/tabbed-portlet/TabbedPortletBodyTab.vue'

import OpportunityDetailsTab from '@/components/opportunity-details/OpportunityDetailsTab.vue'
import ClientInformationTab from '@/components/opportunity-details/ClientInformationTab.vue'
import QuoteRequestFormTab from '@/components/opportunity-details/QuoteRequestFormTab.vue'
import ParentInfoModal from "@/components/opportunity-details/ParentInfoModal.vue";

export default {
  name: 'TabDetails',
  inject: ['$v'],
  components: {
    ParentInfoModal,
    TabbedPortletOpportunity,
    TabbedPortletHead,
    TabbedPortletBody,
    TabbedPortletBodyTab,
    OpportunityDetailsTab,
    ClientInformationTab,
    QuoteRequestFormTab
  },
  data () {
    const OPPORTUNITY_DETAILS_TAB = 'opportunity-details-tab'
    const CLIENT_INFORMATION_TAB = 'client-information-tab'
    const QUOTE_REQUEST_FORM_TAB = 'tab-quote-request-form-tab'

    return {
      showParentModal: false,
      selectedTab: OPPORTUNITY_DETAILS_TAB,
      tabs: {
        OPPORTUNITY_DETAILS_TAB,
        CLIENT_INFORMATION_TAB,
        QUOTE_REQUEST_FORM_TAB
      }
    }
  },
  props: {
    validationGroupName: {
      type: String,
      required: true
    },
    isCompletedQuote: {
      type: Boolean,
      required: false
    },
    save: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      'opportunityDetails': 'opportunity/opportunityDetails',
      'clientDetails': 'opportunity/clientDetails',
      'opportunity': 'opportunity/opportunity',
      'itinerarySourceTypeSelected': 'opportunity/itinerarySourceTypeSelected',
      'opportunitySource': 'opportunity/opportunitySource',
    }),
    itinerary() {
      return this.opportunitySource.itineraries ? this.opportunitySource.itineraries[this.itinerarySourceTypeSelected.index] : null;
    },
  },
  methods: {
    selectTab (tabName) {
      this.selectedTab = tabName
    }
  }
}
</script>
